import { render, staticRenderFns } from "./SecondaryTestimonialsSlider.vue?vue&type=template&id=3d95e0d4&"
import script from "./SecondaryTestimonialsSlider.vue?vue&type=script&lang=js&"
export * from "./SecondaryTestimonialsSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports